import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

//Validate the provided DevExtreme license
export function validateDevExtremeLicense() {
  config({ licenseKey });
}
